import styled, { css } from 'styled-components'

import { mq, sizes } from '../../theme'
import Icon from '../Icon'
import FormSubmitButton from '../../form/FormSubmitButton'

const GlobalStyles1 = css`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSans2XlBold};
`

const GlobalStyles2 = css`
  color: ${({ theme }) => theme.colors.pinkPrimary};
  ${({ theme }) => theme.textStyles.bebas4Xl};
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.bebas6Xl};
  }
`

export const Banner = styled.div`
  padding: 3rem;
  @media ${mq(sizes.tablet)} {
    padding: 4rem;
  }
  background-color: ${({ theme }) => theme.colors.bluePrimary};
  @media ${mq(sizes.desktop)} {
    border-radius: 10px;
  }
`

export const BannerWrapper = styled.div`
  @media ${mq(sizes.scoping)} {
    display: flex;
  }
`

export const Divider = styled.div`
  border-top: 2px dashed ${({ theme }) => theme.colors.greyContour};
  @media ${mq(sizes.tablet)} {
    border-left: 2px dashed ${({ theme }) => theme.colors.greyContour};
  }
`

export const DateLabel = styled.p`
  ${GlobalStyles1};
  @media ${mq(sizes.tablet)} {
    max-width: 9.5rem;
  }
`

export const Date = styled.span`
  ${GlobalStyles2};
`

export const PriceLabel = styled.p`
  ${GlobalStyles1};
  @media ${mq(sizes.tablet)} {
    max-width: 9.5rem;
  }
`

export const PriceBlock = styled.div`
  display: flex;
`

export const Price = styled.p`
  ${GlobalStyles2};
  &:after {
    content: attr(data-prefix);
    vertical-align: text-top;
    font-size: 1.4rem;
    @media ${mq(sizes.tablet)} {
      font-size: 2.4rem;
    }
  }
`

export const GoalsLabel = styled.p`
  ${GlobalStyles1};
`

export const Goals = styled.div`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSansLg};
`

export const PublicPriceLabel = styled.p`
  ${GlobalStyles1}
`

export const PublicPriceBlock = styled.div``

export const PublicPrice = styled.p`
  ${GlobalStyles1}
`

export const DiscountLabel = styled.p`
  ${GlobalStyles1};
  @media ${mq(sizes.tablet)} {
    max-width: 11rem;
  }
`

export const DiscountLegend = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.montserratXl};
`

export const Discount = styled.span`
  ${GlobalStyles1}
`

export const DiscoverOfferBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  @media ${mq(null, sizes.mobile)} {
    flex-direction: column-reverse;
  }
`

export const ImageIcon = styled(Icon)`
  max-width: 8.8rem;
`

export const DiscoverOfferLabel = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSans3Xl};
  @media ${mq(null, sizes.mobile)} {
    text-align: center;
  }
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSans5Xl};
  }
`

export const TextBlockRightWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 1rem;
  border-top: 2px dashed ${({ theme }) => theme.colors.greyContour};
  padding-top: 1rem;
  flex: 1;

  @media ${mq(null, sizes.mobile)} {
    flex-wrap: wrap;
  }
  @media ${mq(sizes.tablet)} {
    border-top: initial;
    padding: 0 0 0 2rem;
  }
`

export const TitleNotConnected = styled.p`
  ${GlobalStyles1};
  margin-bottom: 1rem;
`

export const TextNotConnected = styled.p`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSansLg};
`

export const BannerLeftBlock = styled.div<{ $titleNotConnected?: string }>`
  padding: 2.5rem 4rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 2rem
    ${({ $titleNotConnected }) =>
      $titleNotConnected &&
      css`
        justify-content: center;
      `};

  @media ${mq(sizes.tablet)} {
    flex-direction: ${({ $titleNotConnected }) =>
      $titleNotConnected ? 'column' : 'row'};
    flex-grow: 1;
  }
  @media ${mq(sizes.desktop)} {
    padding: 5rem;
  }
`

export const BannerLeftBlockLeftSide = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  @media ${mq(sizes.desktop)} {
    min-width: 22.5rem;
  }
`

export const BannerLeftBlockRightSide = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2rem;
`

export const BannerRightBlock = styled.div`
  padding: 2rem 4rem;
  background-color: transparent;
  border-left: 4px dashed ${({ theme }) => theme.colors.pureWhite};
  border-bottom: 4px dashed ${({ theme }) => theme.colors.pureWhite};
  border-right: 4px dashed ${({ theme }) => theme.colors.pureWhite};
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${mq(sizes.scoping)} {
    border-left: 4px dashed transparent;
    border-top: 4px dashed ${({ theme }) => theme.colors.pureWhite};
    border-bottom: 4px dashed ${({ theme }) => theme.colors.pureWhite};
    border-right: 4px dashed ${({ theme }) => theme.colors.pureWhite};
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0;
    flex-basis: 30%;
  }
`

export const TextBlockRight = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.pureWhite};
  ${({ theme }) => theme.textStyles.firaSansLgBold};
`

export const VoucherCode = styled.p`
  color: ${({ theme }) => theme.colors.greenAccent};
  ${({ theme }) => theme.textStyles.bebas4Xl};
`

export const Button = styled(FormSubmitButton)`
  margin-top: 1rem;
`
